module.exports = __webpack_public_path__ + "dingbeauty/admin/img/ga_3.d945c06f.jpg";